import { VerificationResult, VerifyStatus } from 'api/LoanOfferApi';
import { VerificationNavigationResult } from 'enums/FlowNextResults';
import { KycStatus } from 'handlers/kyc';

export enum VerificationRedirect {
  WaitForKyc = 'WaitForKyc',
}

export const resolveVerificationRedirect = (
  result: VerificationResult,
  kycStatus?: string,
): VerifyStatus | VerificationNavigationResult | VerificationRedirect.WaitForKyc => {
  if (result.status === VerifyStatus.ManualVerify && result.kycPending) {
    // Alloy can still be pending after documents are required. Send the user to upload.
    if (kycStatus === KycStatus.PendingDocuments) {
      return VerifyStatus.PendingDocuments;
    }
    return VerificationRedirect.WaitForKyc;
  }

  if (result.underwritingPricingDifference) {
    return VerificationNavigationResult.OfferChanged;
  }

  return result.status;
};
